<template>
  <v-container fluid>

		<v-skeleton-loader v-if="isLoading" type="table" />

    <v-row v-if="!isLoading && !errorMessage">
      <v-col cols="12">
        <v-data-table
		ref="dataTable"
          :headers="headers"
          :items="items"
          :search="search"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="apiLoading"
          :loading-text="$t('wkt.admin.common.table.loading')"
          :no-data-text="$t('wkt.admin.common.table.no_data')"
          :no-results-text="$t('wkt.admin.common.table.no_results')"
					:footer-props="{
						'items-per-page-options': [20, 50, 100],
						'items-per-page-text': $t('wkt.admin.common.table.items_per_page'),
						'items-per-page-all-text': $t('wkt.admin.common.table.items_per_page_all')
					}"
          class="elevation-0"
          :fixedHeader="true"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" class="mb-7">
              <v-row cols="12" v-if="!isLoading && !errorMessage" class="d-flex justify-space-between">
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="search"
                    :label="$t('wkt.admin.customers.table.search')"
                    hide-details
                    :clearable="true"
                    @click:clear="searchTimeOut()"
                    @keyup="searchTimeOut()"
                  />
                </v-col>
								<v-col cols="12" md="2" class="d-flex justify-end">
									<v-menu 
									offset-y
									left>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												text
												color="indigo"
												v-bind="attrs"
												v-on="on">
													<v-icon dense color="indigo">file_download</v-icon>
													{{ $t('wkt.admin.common.reports.export') }}
											</v-btn>
											<v-btn
												text
												color="indigo"
												@click="generateLicense()">
													<v-icon dense color="indigo">store</v-icon>
													Generar licencia
											</v-btn>
										</template>										
										<v-list dense>
											<v-list-item @click="downloadXlsReport()">
												<v-list-item-icon>
													<v-icon>grid_on</v-icon>
												</v-list-item-icon>
												<v-list-item-content>
													<v-list-item-title>{{ $t('wkt.admin.customers.reports.customers_excel') }}</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
                </v-col>
              </v-row>
            </v-toolbar>
          </template>

					<template v-slot:[`item`]="{ item }">
						<tr style="cursor: pointer;" @click="editItem(item)">
							<td>{{ item.id }}</td>
							<td :class="item.enabled || !item.name ? 'black--text' : 'red--text'">
								{{ item.enabled != null ? item.name : 'null' }}
							</td>
							<td>{{ getLicenseType(item.licenseType) }}</td>
							<td>{{ getLicensePlan(item.licensePlan) }}</td>
							<td :class="item.licenseEnabled ? 'black--text' : 'red--text'">{{ formatLongDate(item.licensePlanExpires) }} {{ item.licenseEnabled ? '' : 'Deshabilitada'}}</td>
							<td>{{ item.licensePlanAutonrenew ? 'Automática' : 'Manual' }}</td>
							<td>{{ item.currentSeats !== null && item.currentSeatLimit !== null ? `${item.currentSeats}/${item.currentSeatLimit}` : '0/0' }}</td>
							<td>{{ item.currentStorage !== null && item.currentStorageLimit !== null ? `${item.currentStorage.toFixed(3)}/${item.currentStorageLimit} Gb` : '0/0' }}</td>
							<td>{{ item.remainingSignatures ? item.remainingSignatures : '0' }}</td>
							<td>{{ item.emailReport ? item.emailReport : '' }}</td>
							<!-- <td>{{ item.emailSuggestions ? item.emailSuggestions : '' }}</td> -->
							<td>{{ item.partnerName ? item.partnerName : '' }}</td>		
							<td>
								<v-icon 
									v-if="myCompany && myCompany.id != item.id"
									color="#3f51b5" 
									@click.stop="emulateCompany(item)">
									link
								</v-icon>
							</td>			
							<td>
								<v-file-input 
								v-if="myCompany && myCompany.id != item.id"
								class="file-input"
								dense
								hide-input
								v-model="file"
								color="#3f51b5" 
								prepend-icon="cloud_upload"
								@click.stop
								@change="uploadEmployeesFile(item)"/>
							</td>				
						</tr>
					</template>					
					
					<template v-slot:[`footer.page-text`]="props">						
						{{ props.pageStart }} - {{ props.pageStop }} {{ $t('wkt.admin.paged-tables.pager.of') }} {{ props.itemsLength > props.pageStop ? `+${props.pageStop}` : props.pageStop }}
					</template>

					<template v-slot:[`footer.prepend`]>
						<RefreshWidget ref="refresh" style="position: fixed;" @refresh="updateData()" />
					</template>
        </v-data-table>
      </v-col>
    </v-row>

		<v-tooltip v-if="!isLoading" left>
			<template v-slot:activator="{ on, attrs }">				
				<v-btn dark fixed bottom right fab color="#185EA9" v-bind="attrs" v-on="on" @click="addItem()">
					<v-icon dark>add</v-icon>
				</v-btn>
			</template>
			<span>{{ $t("wkt.admin.customers.add_customer_tooltip") }}</span>
		</v-tooltip>

    <CustomersDialog ref='dlgCustomers'/>
    <ImportEmployeesDialog ref='dlgImportEmployees'/>

    <!-- INICIO BLOQUE MENSAJE ESTADO PETICIONES -->
    <v-snackbar
      v-model="showAlert"
      :timeout="alertTimeout"
      :color="alertColor">
        <span style="color: #ffffff;">{{alertText}}</span>
        <v-btn text @click="showAlert=false">
          <span style="color: #ffffff;">Cerrar</span>
        </v-btn>
    </v-snackbar>
    <!-- FIN BLOQUE ESTADO PETICIONES -->

  </v-container>
</template>

<script>
import BaseModule from '../common/BaseModule.js'
import RefreshWidget from '../common/RefreshWidget'
import CustomersDialog from './CustomersDialog'
import ImportEmployeesDialog from './ImportEmployeesDialog'
import api from '../../api/worktime'
import gwt from '../../api/gwt'
import { EventBus }  from '../util/event-bus'

export default {
  name: 'CustomersModule',
  mixins: [BaseModule],
  components: {
		RefreshWidget, CustomersDialog, ImportEmployeesDialog
  },
  data () {
      return { 
        isLoading: false,
				apiLoading: false,
				errorMessage: null,
				showAlert: false,
				alertColor: 'error',
				alertText: '',
				alertTimeout: 3000,
				search: "",
				options: { itemsPerPage: 20 },
				totalItems: 0,				
        headers: [
          { text: this.$t("wkt.admin.customers.table.headers.id"), value: 'id', width: '5%' },
          { text: this.$t("wkt.admin.customers.table.headers.name"), value: 'name', width: '15%' },
          { text: this.$t("wkt.admin.customers.table.headers.license_type"), value: 'licenseType', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.license_plan"), value: 'licensePlan', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.license_plan_expires"), value: 'licensePlanExpires', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.license_plan_autorenew"), value: 'licensePlanAutorenew', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.current_seats_limit"), value: 'currentSeatLimit', width: '10%' },
					{ text: this.$t("wkt.admin.customers.table.headers.current_storage_limit"), value: 'currentStorageLimit', width: '5%' },
          { text: this.$t("wkt.admin.customers.table.headers.remaining_signatures"), value: 'remainingSignatures', width: '5%' },
          { text: this.$t("wkt.admin.customers.table.headers.email_report"), value: 'emailReport', width: '10%' },
        //   { text: this.$t("wkt.admin.customers.table.headers.email_suggestions"), value: 'emailSuggestions', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.partner"), value: 'partnerName', width: '10%' },
          { text: this.$t("wkt.admin.customers.table.headers.emulate_company"), sortable: false, width: '80px' },
          { text: this.$t("wkt.admin.customers.table.headers.import_employees"), sortable: false, width: '80px' },
          //{ text: '', value: 'actions', sortable: false, width: '120px' },
        ],
				items: [],
				partners: [],
				myCompany: null,
				selectedCompanyId: null,
				file: null,
      }
    },
  methods: {
		doShowAlert: function(payload) {
			this.alertText = payload.text;
			this.alertColor = payload.color;
			this.alertTimeout = payload.timeout;
			this.showAlert = true;
		},
		generateLicense() {
		let eventPayload = {
			"mode": "VUEDIALOG",
			"type": "DIALOG_BUILDER",
			"action": "EDIT",
			"payload": 1,
			"eventConfig": {
				"mode": "VUEDIALOG",
				"type": "DIALOG_BUILDER",
				"action": "EDIT",
				"payload": "id",
				"dialogId": "1"
			}
		}
		
		EventBus.$emit('widget-data-click', eventPayload);
        
		},
		searchTimeOut() {
			if (this.timer) {
				clearTimeout(this.timer);
				this.timer = null;
			}
			this.timer = setTimeout(() => {
				this.options.page = 1;
				this.getItems();
			}, 800);
		},
		updateData() {
			this.getItems();
		},
		downloadXlsReport() {			        
			gwt.downloadFile('report/customersExcel', 'customers-excel.xlsx');
		},
		getLicensePlan(type) {
			if (type == null) {
				return '';
			}
					
			var text = '';

			switch (type) {
				case 0:
					text = 'Plan gratuito';
					break;
				case 1:
					text = 'Plan mensual';
					break;
				case 2:
					text = 'Plan anual';
					break;
				default:
					text = '';
					break;
			}
				
			return text;
		},
		getLicenseType(type) {
			if (type == null) {
				return '';
			}

			let text = '';
			switch (type) {
				case 0:
					text = 'FREE';
					break;
				case 1:
					text = 'BUSINESS';
					break;
				case 2:
					text = 'CORPORATE';
					break;
				default:
					text = '';
					break;
			}
			return text;
		},
		addItem() {
			this.openDetailDialog(null);
		},
		editItem(item) {
			var me = this;

			api.getCompanyById(item.id,
				data => {
					me.openDetailDialog(data);
				},
				err => {
					console.log(err);
					this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
		},
		openDetailDialog(data) {
			this.$refs.dlgCustomers.open(this.partners, data, (message, result) => {
				if (result) {
					this.getItems();
					if (message) {
						this.doShowAlert({ text: message, color: 'success', timeout: 3000 });
					}
				} else {
					if (message) {
						this.doShowAlert({ text: message, color: 'error', timeout: 3000 });
					}
				}
			});
		},
		getItems() {
				//this.isLoading = true;
				this.apiLoading = true;
		
				// eslint-disable-next-line no-unused-vars
				const { sortBy, sortDesc, page, itemsPerPage } = this.options;

				api.getCompaniesPaginated((page ? page - 1 : 0) * itemsPerPage, itemsPerPage,  this.search ? this.search : '', sortBy ? sortBy : '', sortDesc,
				data => {
						//this.isLoading = false;
						this.apiLoading = false;
						this.items = data.entities;
						this.totalItems = data.total;

						this.$refs.refresh.update();
				}, err => {
						//this.isLoading = false;
						this.apiLoading = false;
						console.log(err);
						this.doShowAlert({ text: err.message, color: 'error', timeout: 3000 });
				});
		},
		emulateCompany(item) {
			gwt.emulateCompany(item.id);
		},
		uploadEmployeesFile(item) {	
			if (!this.file) {
				return;
			}	
        
			this.selectedCompanyId = item.id;
			this.isLoading = true;

      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('item-id', this.selectedCompanyId);

      api.uploadEmployeesFile(formData,
			(res, isError) => {
        this.isLoading = false;
				this.$refs.dlgImportEmployees.open(res, isError, (deleteFile) => this.importEmployees(deleteFile));
      },
			error => {
        this.isLoading = false;
				console.log(error);
				this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
			});			
		},
		importEmployees(deleteFile) {
      api.importEmployees(this.selectedCompanyId, deleteFile);		
		},
		getPartners() {
				api.getPartners(
				data => {
					this.partners = data;
				}, 
				error => {
					console.log(error);
					this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
				});
		},
    onReveal() {      
			if (!gwt.getSessionInformation()) {
				setTimeout(this.onReveal, 1000);
				return;
			}
			this.myCompany = gwt.getSessionInformation().company;
			this.getPartners();
    }
  },
	watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.getItems();
			},
			deep: true,
		},
	},
}
</script>

<style scoped>
.file-input .v-icon {
	color: blue !important;
}
</style>

